import { render, staticRenderFns } from "./CurriculumList.vue?vue&type=template&id=0309b240&"
import script from "./CurriculumList.vue?vue&type=script&lang=js&"
export * from "./CurriculumList.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports